import { BybButton } from "@Components/common/byb-ds";
import { Stack } from "@mui/material";
import React from "react";
import BybDialog from "../dialog/byb-vr-dialog";

/**
 * This component is part of the VR app V2 redesign
 */

interface IFilterDialog {
  children: React.ReactNode;
  open: boolean;
  onApply: () => void;
  onClose: () => void;
}

const FilterDialog = ({ children, open, onApply, onClose }: IFilterDialog) => {
  return (
    <BybDialog
      open={open}
      name="filters"
      title="Filters"
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": (theme) => ({
          [theme.breakpoints.down("lg")]: {
            minWidth: theme.spacing(72),
          },
        }),
      }}
      dialogActions={
        <>
          <BybButton onClick={onClose} color="secondary" fullWidth>
            Close
          </BybButton>
          <BybButton onClick={onApply} color="primary" fullWidth>
            Apply
          </BybButton>
        </>
      }
    >
      <Stack spacing={5}>{children}</Stack>
    </BybDialog>
  );
};

export default FilterDialog;
